let processing = false;
$(document).ready(function(){
    $('.product-color-button.product-color-click').click(function(e){
        $('.product-color-button').removeClass('active');
        let color = $(this).data('ref');
        let select = $('.js-size_input');
        let name = $('.product-color-name');
        let input = $('#product-color-input');
        let images = $('.product--images');
        // Chargement des images dynamiquement desktop
		$.ajax({
			url: route('models.colors.images', {color_id:color, type:'multiple', display_type:'Desktop'}),
			method: 'get',
			success: (data) => {
                let specificImages = $('#imagesProductCarouselDesktop').parent();
                specificImages.find('img').fadeOut('fast');
                specificImages.html(data).find('img').fadeIn('fast');
			},
			error: (data) => {
				console.error(data);
			}
        });
        // Chargement des images dynamiquement mobile
		$.ajax({
			url: route('models.colors.images', {color_id:color, type:'multiple', display_type:'Mobile'}),
			method: 'get',
			success: (data) => {
                console.log(images)
                let specificImages = $('#imagesProductCarouselMobile').parent();
                specificImages.find('img').fadeOut('fast');
                specificImages.html(data).find('img').fadeIn('fast');
			},
			error: (data) => {
				console.error(data);
			}
        });
        // Chargement de l'image du modal
		$.ajax({
			url: route('models.colors.images', {color_id:color,type:'unique'}),
			method: 'get',
			success: (data) => {
                // Ajout de la première option
                $('.addedToCartModal img').attr('src', data);
			},
			error: (data) => {
				console.error(data);
			}
        });
        // Modification des tailles via ajax
		$.ajax({
			url: route('models.colors.sizes', {color_id:color}),
			method: 'get',
			success: (data) => {
                // Récupération du texte traduit
                let placeholder = $('#exemple-choose-size').text();
                // Ajout de la première option
                let array = Object.entries(data);
                array.unshift(['', placeholder]);
                // Mise en place des options
                select.empty();
                array.forEach(size => {
                    var o = new Option(size[1], size[0]);
                    select.append(o);
                });
                if (array.length === 2) {
                    let sizeId = array[1][0]
                    //in that case, no size are shown
                    //update size attr
                    select.val(sizeId)
                    select.hide()
                } else {
                    select.show()
                }
			},
			error: (data) => {
				console.error(data);
			}
        });
        let priceDisplay = $('.product-prices-display');
        // Récupération du nouveau prix via ajax
        $.ajax({
            url: route('models.colors.prices', {color_id:color}),
            method: 'get',
            success: (data) => {
                priceDisplay.text(data + ' €');
            },
            error: (data) => {
                console.error(data);
            }
        });
        // Modification du nom de la couleur
        name.text($(this).data('color'));
        input.val(color);
        $(this).addClass('active');
    });

    $('.js-size_input').change(function(e){
        let value = $(this).val();
        if(value){
            let priceDisplay = $('.product-prices-display');
            let checkStock = $('.check-stock-display');
            let hiddenQty = $('.js-qty_input')
            // Récupération du nouveau prix via ajax
            $.ajax({
                url: route('models.products.prices', {product_id:value}),
                method: 'get',
                dataType: "JSON",
                success: (data) => {
                    let okstock = `<button id="cartSubmitButton" type="submit" class="btn btn-dark ml-auto btn-svg">${data.text}</button>`
                    let nostock = `<div id="noStockDiv"><span>${data.nostock}</span></div>`
                    priceDisplay.text(data.price + ' €');
                    hiddenQty.val(data.cartProductQty);
                    data.stock <= data.stock_min ? checkStock.html(nostock) : checkStock.html(okstock);
                },
                error: (data) => {
                    console.error(data);
                }
            });
        }
    });
    
    $('.product-color-button.product-color-hover').hover(function(e){
        $('.product-color-button').removeClass('active');
        let url = $(this).data('url');
        let model = $(this).data('model');
        let img = $('.img_categ_details_' + model);
        // Chargement de l'image via le data url
        if(img.attr('src') != url){
            img.fadeOut('fast').promise().done(function(){
                $(this).attr('src', url).fadeIn('fast');
            });
        }
        $(this).addClass('active');
    });
});